import { ReactNode, memo } from 'react';

import { Heading } from 'components/ui/typography';
import Text from 'components/ui/typography/Text';

/**
 * Page Sub Header component
 * @param {String, Node} title - Sub Header Title
 * @param {Node} leftSection - Left Section for header Any node
 * @param {Node} rightSection - Right Section for header Any node
 * @param {Node} children - Any node
 */

type PageHeaderProps = {
  title: string | ReactNode;
  description?: string | ReactNode;
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  children?: ReactNode;
};

export const PageHeader = memo<PageHeaderProps>(
  ({ title, leftSection, rightSection, children, description }) => (
    <div className="py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          {leftSection && leftSection}
          {typeof title === 'string' ? <Heading className="text-2xl font-bold text-slate-100">{title}</Heading> : title}
        </div>
        {rightSection && rightSection}
      </div>
      {description && (
        <Text variant="description" className="">
          {description}
        </Text>
      )}
      {children && children}
    </div>
  ),
);

PageHeader.displayName = 'PageHeader';

export default PageHeader;
